module.exports = __webpack_public_path__ + "img/pore_survey_4.94be444d.png";